import { ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore, UserStore } from "../../stores";

export class NotFoundResponseHandlingMiddleware implements IMiddelware {
  public readonly unhandledHttpStatusCodes = [404];

  constructor(
    private readonly globalErrorsStore: GlobalErrorsStore,
    private readonly userStore: UserStore,
  ) {}

  public async post(context: ResponseContext): Promise<void> {
    if (this.unhandledHttpStatusCodes.includes(context.response.status)) {
      this.setError(context);
    } else {
      this.resetError();
    }
  }

  public resetError() {
    this.globalErrorsStore.removeError(translationKeys.globalErrors.notFoundError);
  }

  public setError(context: ResponseContext) {
    // #58176 matches "/api/Disclaimer" and ensures both params "type="" and "language="" are included in the url
    if (context.url.includes("/Disclaimer") && context.url.includes("type=bing") && context.url.includes("language=")) {
      console.error(`Disclaimer not found for Type = "bing" and Language = "${this.userStore.currentLanguage.code}".`);
      return;
    }

    if (context.url.includes("/Cancel")) {
      const currentHeaders = context.init.headers as any;
      console.error("Process cancellation failed for Process with ID", currentHeaders?.processId);
      return;
    }

    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.notFoundError);
  }
}
